import React, { useState, useEffect } from "react"
import { StaticImage } from "gatsby-plugin-image"
import Layout from "../components/layout"
import CountUp from "react-countup"
import { FormattedMessage, useIntl } from "gatsby-plugin-intl"
import SelectItem from '../components/FormItem/Select'
import { storage, getOpenCountryList, getCountryCode, getCurrentCountry, getCurrentLanguage } from '../utils'
import * as api from '../services'
import * as R from 'ramda'
import '../style/index.scss'

interface FormInfoContent {
  name: string
  phone: string
  email: string
  restaurantName: string
  restaurantAddress: string
  restaurantType: string
  restaurantDesc: string
  channel: string
}
interface InfoState {
  content: FormInfoContent
  wechatId: string
}

const initValues: InfoState = {
  content: {
    name: '',
    phone: '',
    email: '',
    restaurantName: '',
    restaurantAddress: '',
    restaurantType: '',
    restaurantDesc: '',
    channel: '',
  },
  wechatId: ''
}

const IndexPage = () => {
  const intl = useIntl()
  const init = 10
  const [count1, setCount1] = useState(init)
  const [count2, setCount2] = useState(init)
  const [count3, setCount3] = useState(init)
  const [selectCountry, setCountry] = useState('')
  const [wechatList, setWechatList] = useState<FormItemState[]>([])
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [submitSucceed, isSubmitSucceed] = useState(false)
  const [formClosed, setFormClosed] = useState(false)
  const [values, setValues] = useState<InfoState>(initValues)
  useEffect(() => {
    setTimeout(() => {
      setCount1(3600000)
      setCount2(75000)
      setCount3(80000)
    }, 300)
  }, [])

  let countryList = getOpenCountryList().map((country: KeyValue) => {
    country.label = intl.formatMessage({ id: `global.${country.id}` })
    country.type = 'option'
    return country
  })
  
  // 语言为法语，国家只能选择CA
  if (getCurrentLanguage() === 'fr') {
    countryList = [{id: 'CA', code: 'CA', label: intl.formatMessage({ id: 'global.CA' }), type: 'option'}]
  }
  
  const registInfo: FormItemState[] = [
    {
      id: 'country',
      label: 'form.country',
      type: 'select',
      placeholder: 'form.placeholder.country',
      onChange: (country: string) => {
        setCountry(country)
        storage.store('country', country)
        getWechatList()
      },
      options: countryList as FormItemState[]
    },
    {
      id: 'wechat',
      label: 'form.wechat',
      type: 'select',
      placeholder: 'form.placeholder.wechat',
      options: wechatList,
      onChange: (wechatId: string) => {
        setValues({...values, wechatId})
      }
    },
    {
      id: 'name',
      label: 'form.name',
      type: 'input',
      placeholder: 'form.placeholder.name'
    },
    {
      id: 'phone',
      label: 'form.phone',
      type: 'input',
      placeholder: 'form.placeholder.phone'
    },
    {
      id: 'email',
      label: 'form.email',
      type: 'input',
      placeholder: 'form.placeholder.email'
    },
    {
      id: 'restaurantName',
      label: 'form.restaurantName',
      type: 'input',
      placeholder: 'form.placeholder.restaurantName'
    },
    {
      id: 'restaurantAddress',
      label: 'form.restaurantAddress',
      type: 'input',
      placeholder: 'form.placeholder.restaurantAddress'
    },
    {
      id: 'restaurantType',
      label: 'form.restaurantType',
      type: 'input',
      placeholder: 'form.placeholder.restaurantType',
    },
    {
      id: 'channel',
      label: 'form.channel',
      type: 'select',
      placeholder: 'form.placeholder.channel',
      onChange: (channelId: string) => {
        setItemValue(channelId, 'channel')
      },
      options: [
        {
          id:'instagram',
          label:'form.channelOptions.instagram',
          type: 'option',
        },
        {
          id:'facebook',
          label:'form.channelOptions.facebook',
          type: 'option',
        },
        {
          id:'wechat',
          label:'form.channelOptions.wechat',
          type: 'option',
        },
        {
          id:'red_book',
          label:'form.channelOptions.red_book',
          type: 'option',
        },
        {
          id:'app_store',
          label:'form.channelOptions.app_store',
          type: 'option',
        },
        {
          id:'referral',
          label:'form.channelOptions.referral',
          type: 'option',
        },
        {
          id:'other',
          label:'form.channelOptions.other',
          type: 'option',
        },
      ]
    },
    {
      id: 'restaurantDesc',
      label: 'form.restaurantDesc',
      type: 'textarea',
      placeholder: 'form.placeholder.restaurantDesc'
    }
  ]
  
  const errorListTips = {
    name: intl.formatMessage({ id: 'form.errorListTips.name' }),
    phone: intl.formatMessage({ id: 'form.errorListTips.phone' }),
    email: intl.formatMessage({ id: 'form.errorListTips.email' }),
    restaurantName: intl.formatMessage({ id: 'form.errorListTips.restaurantName' }),
    restaurantAddress: intl.formatMessage({ id: 'form.errorListTips.restaurantAddress' }),
    restaurantType: intl.formatMessage({ id: 'form.errorListTips.restaurantType' }),
    channel: intl.formatMessage({ id: 'form.errorListTips.channel' })
  }

  const setItemError = (id, tips) => {
    const label = document.querySelector(`[id=${id}]`)?.parentElement
    if (label) {
      label.setAttribute('error-tips', tips)
      label.className = 'error'
    }
  }

  const setItemValue = (value, id) => {
    const content = Object.assign(values.content, {[id]: value})
    setValues(Object.assign(values, { content }))
  }

  const changeItemData = ({ item, callback, id }) => {
    item.target.parentElement.className = ''
    if (!callback) {
      setItemValue(item.target.value, id)
    }
    callback && callback()
  }

  const resetForm = (success = false) => {
    isSubmitSucceed(success)
    setIsSubmitted(false)
    setCountry('')
    setValues(R.clone(initValues))
  }

  const renderFormItem = (item: FormItemState) => {
    switch(item.type) {
      case 'input':
        return <label><input id={item.id} placeholder={intl.formatMessage({ id: item.placeholder })} onChange={(event) => {
          changeItemData({item: event, callback: item.onChange, id: item.id})
        }} /></label>
      case 'textarea':
        return <label><textarea id={item.id} title={item.label} placeholder={intl.formatMessage({ id: item.placeholder })} onChange={(event) => {
          changeItemData({item: event, callback: item.onChange, id: item.id})
        }} /></label>
      case 'select':
        return <label>
          <SelectItem id={item.id} options={item.options} onChange={(event, value) => {
            changeItemData({item: event, callback: () => {item.onChange && item.onChange(value)}, id: item.id})
          }} placeholder={intl.formatMessage({ id: item.placeholder })} />
        </label>
      case 'option':
        return <option key={item.id} value={item.id}>{item.label}</option>
    }
  }

  const getWechatList = async () => {
    setWechatList([])
    try {
      setValues({...values, wechatId: ''})
      const { data } = await api.simpleWechatForCountry()
      setWechatList((data || []).map((wechat: KeyValue) => {
        wechat.label = wechat.alias || wechat.name
        wechat.type = 'option'
        return wechat
      }) as FormItemState[])
    } catch (error) {
      console.error(error)
    } 
  }

  const submit = async () => {
    let noError = true
    const { content, wechatId } = values
    const setError = (id: string, msg: string) => {
      noError = false
      setItemError(id, intl.formatMessage({ id: msg }))
    }
    if (!selectCountry) {
      setError('country', 'form.errorListTips.country')
    }
    if (!wechatId) {
      setError('wechat', 'form.errorListTips.wechat')
    }
    for (let i in content) {
      if (!content[i] && errorListTips[i]) {
        setError(i, errorListTips[i])
      } else {
        if (i === 'email') {
          if (!/\S+@\S+\.\S+/.test(content[i])) {
            setError(i, 'form.errorListTips.emailError')
          }
        }
        if (i === 'phone') {
          if (!getCountryCode().phoneReg.test(content[i])) {
            setError(i, 'form.errorListTips.phoneError')
          }
        }
      }
    }
    if (!noError) {
      document.querySelector('label.error')?.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"})
      return
    }
    try {
      await api.registerNew(values)
      resetForm(true)
    } catch (error) {
      console.error(error)
      isSubmitSucceed(false)
    } finally {
      setIsSubmitted(true)
    }
    
  }

  return <Layout>
    <div className="container">
      <div className="top-content">
        <div className="banner">
          <div className="top-left">
            <div className="title"><FormattedMessage id='partner.title' /></div>
            <div className="description">
              <FormattedMessage id='partner.banner.desc' />
            </div>
          </div>
          {!formClosed && <div className="top-right">
            {!isSubmitted ? <div>
              <div className="title"><FormattedMessage id="form.title" /></div>
              <div className="content">
                {registInfo.map(info => <div key={info.id} className='form-item'>{renderFormItem(info)}</div>)}
              </div>
              <div className="submit">
                <button title="submit" type="button" className='sub-btn' onClick={submit}><FormattedMessage id='form.btn1' /></button>
              </div>
            </div> : submitSucceed ? <div className="succeed-box">
              <StaticImage
                src="../images/succeed.png"
                width={200}
                quality={95}
                formats={["auto", "webp", "avif"]}
                alt="Fantuan Delivery"
              />
              <div className="tips"><FormattedMessage id='form.success.title' /></div>
              <div className="submit">
                <button type="button" title="finish" className='succeed-btn' onClick={() => { setIsSubmitted(false) }}><FormattedMessage id='form.success.btn' /></button>
              </div>
            </div> : <div className="succeed-box">
              <StaticImage
                src="../images/failed.png"
                width={200}
                quality={95}
                formats={["auto", "webp", "avif"]}
                alt="Fantuan Delivery"
              />
              <div className="tips"><FormattedMessage id='form.error.title' /></div>
              <div className="submit">
                <button type="button" title="retry" className='succeed-btn' onClick={() => {resetForm()}}><FormattedMessage id='form.error.btn' /></button>
              </div>
            </div>}
          </div>}
        </div>
      </div>
      <div className='middle-content'>
        <div className='cont-line'>
          <div className='line-item'>
            <StaticImage
              src="../images/customers.png"
              width={100}
              quality={95}
              formats={["auto", "webp", "avif"]}
              alt="Fantuan Delivery"
            />
            <div className='context-box'>
              <div className='title'><FormattedMessage id='partner.advantage.a.title' /></div>
              <div className='context'>
                <FormattedMessage id='partner.advantage.a.desc' />
              </div>
            </div>
          </div>
          <div className='line-item'>
            <StaticImage
              src="../images/costs.png"
              width={100}
              quality={95}
              formats={["auto", "webp", "avif"]}
              alt="Fantuan Delivery"
            />
            <div className='context-box'>
              <div className='title'><FormattedMessage id='partner.advantage.b.title' /></div>
              <div className='context'><FormattedMessage id='partner.advantage.b.desc' /></div>
            </div>
          </div>
        </div>
        <div className='cont-line'>
          <div className='line-item'>
            <StaticImage
              src="../images/efficiency.png"
              width={100}
              quality={95}
              formats={["auto", "webp", "avif"]}
              alt="Fantuan Delivery"
            />
            <div className='context-box'>
              <div className='title'><FormattedMessage id='partner.advantage.c.title' /></div>
              <div className='context'>
                <FormattedMessage id='partner.advantage.c.desc' />
              </div>
            </div>
          </div>
          <div className='line-item'>
            <StaticImage
              src="../images/expansion.png"
              width={100}
              quality={95}
              formats={["auto", "webp", "avif"]}
              alt="Fantuan Delivery"
            />
            <div className='context-box'>
              <div className='title'><FormattedMessage id='partner.advantage.d.title' /></div>
              <div className='context'><FormattedMessage id='partner.advantage.d.desc' /></div>
            </div>
          </div>
        </div>
      </div>
      <div className='bottom-content'>
        <div className='bottom-content-item'>
          <div className='number'><CountUp end={count1} duration={3} separator="," />+</div>
          <div className='title'><FormattedMessage id='partner.numbers.a.title' /></div>
          <div className="label"><FormattedMessage id='partner.numbers.a.desc' /></div>
        </div>
        <div className='bottom-content-item'>
          <div className='number'><CountUp end={count2} duration={3} separator="," />+</div>
          <div className='title'><FormattedMessage id='partner.numbers.b.title' /></div>
          <div className="label"><FormattedMessage id='partner.numbers.b.desc' /></div>
        </div>
        <div className='bottom-content-item'>
          <div className='number'><CountUp end={count3} duration={3} separator="," />+</div>
          <div className='title'><FormattedMessage id='partner.numbers.c.title' /></div>
          <div className="label"><FormattedMessage id='partner.numbers.c.desc' /></div>
        </div>
      </div>
    </div>
  </Layout>
}

export default IndexPage
